module.exports = __webpack_public_path__ + "static/media/logo-horiz-white@4x.22c9637e.png";